import { render, staticRenderFns } from "./DeviceDetails.vue?vue&type=template&id=5fd32a00&scoped=true&"
import script from "./DeviceDetails.vue?vue&type=script&lang=js&"
export * from "./DeviceDetails.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetails.vue?vue&type=style&index=0&id=5fd32a00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd32a00",
  null
  
)

export default component.exports